import { Col, Form, Input } from "antd";

const MechanicUserListFilter = ({ initialTableData }) => {
  return (
    <>
      <Col span={3}>
        <Form.Item label="Name" name="name">
          <Input placeholder="Enter Name" size="small" />
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Email" name="email">
          <Input placeholder="Enter Email" size="small" />
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="ID Card No" name="id_card_no">
          <Input placeholder="Enter ID Card No" size="small" />
        </Form.Item>
      </Col>
    </>
  );
};

export default MechanicUserListFilter;
